import { render, staticRenderFns } from "./OurNetwork.vue?vue&type=template&id=13e028c3"
import script from "./OurNetwork.vue?vue&type=script&lang=js"
export * from "./OurNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports